import React, { useContext } from "react";
import useUpdateOccurenceValue from "./useUpdateOccurenceValue.js";
import useGetApiData from "./useGetApiData.js";
import useGetValueFromArray from "./useGetValueFromArray.js";
import useApiOperation from "./useApiOperation.js";
import useSetActualizeData from "./useSetActualizeData.js";

import { store } from "../store.js";

const useExecuteAction = () => {
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const updateValue = useUpdateOccurenceValue();
  const getValueFromArray = useGetValueFromArray();
  const getApiData = useGetApiData();
  const setActualizeData = useSetActualizeData();
  
  const callApi = useApiOperation(globalState.state.formData.lists.validations.events.api.options);
  
  const executeAction = (updatedFormData, control, event, isExecutionMode) => {
    
    const currentApi = getApiByControlAndEvent(control, event)
    
    if (currentApi) {
      const responsePromise = callApi(currentApi)
      const apiGlobalId = currentApi.Schemas.Content.globalId
      responsePromise.then(response => {
        if (updatedFormData.apiData){
          updatedFormData.apiData = updatedFormData.apiData.filter(item => item.globalId != apiGlobalId)
          updatedFormData.apiData.push({globalId:apiGlobalId, id:currentApi.id,  data:response})
        }
        else 
          updatedFormData.apiData = [{globalId:apiGlobalId, id:currentApi.id,  data:response}]
        
          
        changeMappingData(updatedFormData, apiGlobalId, response, updatedFormData) 
        updatedFormData.isExecutionMode = isExecutionMode
        dispatch({
          type: "UPDATE_FORM_WITOUT_HISTORIQUE",
          payload: updatedFormData,
        });
      })
    } else {
      if (updatedFormData.isExecutionMode != isExecutionMode) {
        updatedFormData.isExecutionMode = isExecutionMode
        dispatch({
          type: "UPDATE_FORM_WITOUT_HISTORIQUE",
          payload: updatedFormData,
        });
      }
    }


  }
 /*
  const setActualizeData = (control, apiId, apiData) => {
    const currentMapping = getMappingByControl(control)
    control.properties.actualize.value = currentMapping && currentMapping.value[0] == apiId
    
    const dataSourcePath = currentMapping.value
    const pathName = getValueFromArray(dataSourcePath).name
    let pathNames =  pathName.split(".")
    pathNames = pathNames.slice(1, pathNames.length)
        
    const data = getApiData(pathNames, apiData)

    const isArray = Array.isArray(data)
    control.properties.size.value = isArray ? data.length : 0
      
  };
  */

  /*
  const setData = (control, apiId, apiData, formData) => {
    const currentMapping = getMappingByControl(control)
    
    if (currentMapping && currentMapping.value[0] == apiId) {
      const dataSourcePath = currentMapping.value
      const pathName = getValueFromArray(dataSourcePath).name
      let pathNames =  pathName.split(".")
      pathNames = pathNames.slice(1, pathNames.length)
          
      const data = getApiData(pathNames, apiData)
      
      switch (control.type) {
        case "DataGrid":
          control.metaData.filter(item => item.type == "Row").metaData = []
          var rows = control.metaData.filter(item => item.type == "Rows")[0]
          
          rows = JSON.parse(JSON.stringify(rows))
          rows.metaData.forEach(col => {
            var value = col.properties.text.value
            if (typeof value == "object") {
              
              if (Array.isArray(value.id)) {
                let pathid = undefined
                const detail = currentMapping.details.filter(item => item.key.value.slice(-1) == col.globalId + "_id")[0]
                pathid = detail && detail.value.value
                if (pathid && Array.isArray(pathid)) 
                  col.properties.text.value.id = getValueFromArray(pathid, undefined, dataSourcePath ).name
              }
              if (Array.isArray(value.item)) {
                let pathid = undefined
                const detail = currentMapping.details.filter(item => item.key.value.slice(-1) == col.globalId + "_item")[0]
                pathid = detail && detail.value.value
                if (pathid && Array.isArray(pathid)) 
                  col.properties.text.value.item = getValueFromArray(pathid, undefined, dataSourcePath ).name
              }
              if (Array.isArray(value.value)) {
                let pathid = undefined
                const detail = currentMapping.details.filter(item => item.key.value.slice(-1) == col.globalId + "_value")[0]
                pathid = detail && detail.value.value
                if (pathid && Array.isArray(pathid)) 
                  col.properties.text.value.value = getValueFromArray(pathid, undefined, dataSourcePath ).name
              }
            }
            else{
              let pathid = undefined
              const detail = currentMapping.details.filter(item => item.key.value.slice(-1) == col.globalId)[0]
              pathid = detail && detail.value.value
              if (pathid && Array.isArray(pathid)) 
                col.properties.text.value = getValueFromArray(pathid, undefined, dataSourcePath ).name
            }
           
            if (col.type == "ListBox" || col.type == "AutoComplete") 
              setData(col, apiId, apiData, formData)
            
          })
          var nRow = 4 // SearchBar + Headerbar + FilterBar + Rows
          const n = isNaN(control.properties.sliceSize.value) ? 10 : control.properties.sliceSize.value
          const isArray = Array.isArray(data)
          
          isArray && data.slice(0, n).forEach((lineData, i) => {
            var newRow =  JSON.parse(JSON.stringify(rows))
            newRow.type = "Row"
            
            nRow = nRow + i
           
            
            newRow.metaData.forEach((col, index) => {
              var value = col.properties.text.value
             
              if (typeof value == "object") {
                  col.properties.text.value.id = value.id && value.id != "" ? getApiData(value.id.split("."), lineData, index) 
                  : (typeof lineData == "object" ? "" : lineData)
                  col.properties.text.value.item = value.item && value.item != "" ? getApiData(value.item.split("."), lineData, index) 
                  : (typeof lineData == "object" ? "" : lineData)
              }
              else{
                  col.properties.text.value = value && value != "" ? getApiData(value.split("."), lineData, index) 
                  : (typeof lineData == "object" ? "" : lineData)
              }
            })

           
            handleOnDrop(formData, {id:[control.id, ...control.parentId], globalId:[control.globalId, ...control.parentGlobalId]}
              , {...newRow, id:0}, {type:"Row", index:nRow})
          })
          control.properties.size.value = isArray ? data.length : 0
          
          break;
        case "ListBox":
        case "AutoComplete":
          var value = {id:"", item:""}
          
         

          let pathId = undefined
          let detail = currentMapping.details.filter(item => item.key.value.slice(-1) == control.globalId + "_id")[0]
          pathId = detail && detail.value.value
          if (pathId && Array.isArray(pathId)) 
            value.id = getValueFromArray(pathId, undefined, dataSourcePath ).name
          
          //let pathid = undefined
          detail = currentMapping.details.filter(item => item.key.value.slice(-1) == control.globalId + "_item")[0]
          pathId = detail && detail.value.value
          if (pathId && Array.isArray(pathId)) 
            value.item = getValueFromArray(pathId, undefined, dataSourcePath ).name
          
          detail = currentMapping.details.filter(item => item.key.value.slice(-1) == control.globalId + "_value")[0]
          pathId = detail && detail.value.value
          if (pathId && Array.isArray(pathId)) 
            value.value = getValueFromArray(pathId, undefined, dataSourcePath ).name

          
          
          control.properties.data.value.mapping.data = []
          Array.isArray(data) && data.forEach((lineData, index) => {
            var newItem = JSON.parse(JSON.stringify(value))
            newItem.id = value.id && value.id != "" ? getApiData(value.id.split("."), lineData, index) 
            : (typeof lineData == "object" ? "" : lineData)
            newItem.item = value.item && value.item != "" ? getApiData(value.item.split("."), lineData, index) 
            : (typeof lineData == "object" ? "" : lineData)
            newItem.value = value.value && value.value != "" ? getApiData(value.value.split("."), lineData, index) 
            : (typeof lineData == "object" ? "" : lineData)
            control.properties.data.value.mapping.data.push(newItem)
          })
          break;
      
      } 
    } 
    
  };
*/
  const changeMappingData = (updatedFormData, apiId, apiData, formData) => { 
    if (!updatedFormData.metaData) return;
    updatedFormData.metaData.map(control =>{
      const value = control.properties.text.value
      if (Array.isArray(value)  && value.includes(apiId)) {
        updateValue(value, "text", "properties", true, globalState.state.formData.actions.event.type.onLoad
        , {actualToolGlobalIds:[control.globalId], actualToolIds:[control.id]}, undefined, updatedFormData
        , { maskData : control.properties.masks ? control.properties.masks.value : "", 
            prefix : control.properties.prefix ? control.properties.prefix.value : "",
            suffix : control.properties.suffix ? control.properties.suffix.value : "",
            groupSeparator : control.properties.groupSeparator ? control.properties.groupSeparator.value : "",
            groupSize : control.properties.groupSize ? parseInt(control.properties.groupSize.value) : "",
            } )
       } 
      //else if (control.type == "ListBox" || control.type == "AutoComplete") // || control.type == "DataGrid"
        //setData(control, apiId, apiData, formData)
      else if (control.type == "ListBox" || control.type == "AutoComplete" || control.type == "DataGrid") // || control.type == "DataGrid"
        setActualizeData(control, apiId, apiData)

      changeMappingData(control, apiId, apiData, formData)
    })
    
  }
  
  const getMappingByControl = (control) => { 
    
    if(control.properties.data && control.properties.data.option == globalState.state.formData.actions.option.mapping){
      
      return control.properties.data.value.mapping.values
              .filter(item => item.id == control.properties.data.value.mapping.id)[0]
    }
    return undefined
    
  }


  const getApiByControlAndEvent = (control, event) => { 
    
    var controlByEvent = JSON.parse(JSON.stringify(control))

    if (event != globalState.state.formData.actions.event.type.onLoad) controlByEvent = control.events[event]
   
    if(controlByEvent.properties.actions && controlByEvent.properties.actions.option == globalState.state.formData.actions.option.api)
      return controlByEvent.properties.actions.api.values.values
              .filter(item => item.id == controlByEvent.properties.actions.api.values.id)[0]
    return undefined
  }

  return executeAction;
};

export default useExecuteAction;
